import about1 from "../assets/images/GAS/aboutg2.jpg";
import about2 from "../assets/images/GAS/aboutG1.jpg";

function About() {
  return (
    <>
      <section className="about-three py-120 rpy-100 mb-0" id="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-three-image rmb-60 mr-10 rmr-0 wow fadeInLeft delay-0-2s">
                <img src={about1} alt="About Image 1" />
                <img src={about2} alt="About Image 2" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content pl-70 rpl-0 wow fadeInRight delay-0-2s">
                <div className="section-title mb-35">
                  <span className="sub-title text-align-left">About Us</span>
                  <h2 className="textIndand">RAJESWARI MAPOSI INDANE AGENCY</h2>
                </div>
                <p className="aboutPara">
                  Rajeswari Maposi Indane Agency is an Indane LPG distributor
                  located in Tondiarpet, Chennai. They provide both domestic
                  (14.2 kg, 5 kg) and commercial (19 kg, 47.5 kg) LPG cylinders.
                  The agency operates from Monday to Saturday, 9:00 AM to 1:00
                  PM and 2:00 PM to 5:00 PM, with a lunch break from 1:00 PM to
                  2:00 PM. Customers can book LPG through WhatsApp, missed
                  calls, SMS, or the IndianOil One app. They also accept
                  payments via Bharat Bill Payment System. The agency is known
                  for reliable service in the area. For queries, they can be
                  contacted via phone or email. The office remains closed on
                  Sundays.
                </p>
                <ul className="list-style-three mt-15">
                  <li>Domestic and commercial LPG cylinders available.</li>
                  <li>
                    Open Monday to Saturday, 9:00 AM - 1:00 PM & 2:00 PM - 5:00
                    PM (Lunch break: 1:00 PM - 2:00 PM).
                  </li>
                  <li>Closed on Sundays.</li>
                  <li>Book via WhatsApp, missed calls, SMS, or app.</li>
                  <li>Payments accepted through Bharat Bill Payment System.</li>
                </ul>
                <div className="contact-info mt-20">
                  <h4>Office Contact Number</h4>
                  <p>91766 13644 / 95517 424365 / 89399 49936</p>
                  <p>
                    Email:{" "}
                    <a href="mailto:maposithiru@gmail.com">
                      maposithiru@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
